import { StyledIcon } from 'src/components/foundations/foundations.styles';
import { textStyleCss } from 'src/theme/atlas';
import { FormState } from 'src/types';
import styled, { DefaultTheme } from 'styled-components';

export const getAlertTextColor = (state: FormState, theme: DefaultTheme) => {
  switch (state) {
    case FormState.WARNING:
      return theme.atlas.semantic.color.status.warning.text;
    case FormState.ERROR:
      return theme.atlas.semantic.color.status.error.text;
    case FormState.SUCCESS:
      return theme.atlas.semantic.color.status.success.text;
    default:
      return theme.atlas.semantic.color.type.default;
  }
};

const getAlertDisplayStyles = (state: FormState, theme: DefaultTheme) => {
  switch (state) {
    case FormState.WARNING:
      return `
        border-color: ${theme.atlas.semantic.color.status.warning.text};
        background-color: ${theme.atlas.semantic.color.status.warning.background};
      `;
    case FormState.ERROR:
      return `
        border-color: ${theme.atlas.semantic.color.status.error.text};
        background-color: ${theme.atlas.semantic.color.status.error.background};
      `;
    case FormState.SUCCESS:
      return `
        border-color: ${theme.atlas.semantic.color.status.success.text};
        background-color: ${theme.atlas.semantic.color.status.success.background};
      `;
    default: {
      const borderColor = theme.isVaultVariant
        ? theme.atlas.semantic.color.outline.default
        : theme.atlas.semantic.color.status.notification.text;
      const backgroundColor = theme.isVaultVariant
        ? theme.atlas.semantic.color.surface.default
        : theme.atlas.semantic.color.status.notification.background;
      return `
        border-color: ${borderColor};
        background-color: ${backgroundColor};
      `;
    }
  }
};

export const InformationBannerStyled = styled.div<{
  state: FormState;
  $descriptionLineDrop?: boolean;
  $fullWidth?: boolean;
  $centerIconVertically?: boolean;
}>`
  display: flex;
  ${(props) => props.$centerIconVertically && `align-items: center;`}
  border: 1px solid;
  ${(props) => getAlertDisplayStyles(props.state, props.theme)}
  white-space: ${(props) =>
    props.$descriptionLineDrop ? `pre-line` : `normal`};
  width: ${(props) => (props.$fullWidth ? '100%' : 'calc(100% - 32px)')};
  border-radius: 4px;
  gap: 16px;
  padding: 16px;
`;

export const InformationBannerTitle = styled.h4<{ state?: FormState }>`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.body)}
  font-weight: 600;
  color: ${(props) =>
    props.state === FormState.DEFAULT && !props.theme.isVaultVariant
      ? props.theme.atlas.semantic.color.status.notification.text
      : props.theme.atlas.semantic.color.type.default};
  margin: 0;
`;

export const InformationBannerDescription = styled.p<{ state: FormState }>`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  color: ${(props) =>
    props.state === FormState.DEFAULT && !props.theme.isVaultVariant
      ? props.theme.atlas.semantic.color.status.notification.text
      : props.theme.atlas.semantic.color.type.default};
  margin: 0;
`;

export const InformationBannerDetails = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const CloseIcon = styled(StyledIcon)`
  cursor: pointer;
`;
